'use client';

import { TEST_IDS } from '@repo/sdk/constants';
import { withFieldGroup } from '../../lib/app-form-hook.tsx';
type LocationDetailsFieldsProps = {
  disabled?: boolean;
};
const locationDetailsFieldsProps: LocationDetailsFieldsProps = {};
export const LocationDetailsFields = withFieldGroup({
  defaultValues: {
    instructions: '',
    name: ''
  },
  props: locationDetailsFieldsProps,
  render: function Render({
    disabled,
    group
  }) {
    return <section className="flex flex-col gap-6">
        <h3 className="text-2xl font-bold">Location</h3>
        <group.AppField name="name">
          {field => <field.Input data-testid={TEST_IDS.companyLocation.form.nameInput} disabled={disabled} label="Name *" placeholder="Type a name" />}
        </group.AppField>
        <group.AppField name="instructions">
          {field => <field.Textarea data-testid={TEST_IDS.companyLocation.form.instructionsTextarea} disabled={disabled} label="Instructions" lengthLimit={160} placeholder="Add additional details to help identify the correct location. This information is visible to the driver." rows={3} />}
        </group.AppField>
      </section>;
  }
});